export const APP_PATH = "/";
export const SIGN_IN_PATH = "/log-in";
export const SIGN_OUT_PATH = "/log-out";
export const TAGS_AND_METADATA_PATH = "/tags-metadata";
export const STUDIOS_PATH = "/studios";
export const MODULES_PATH = "/modules";
export const CONTENT_SCHEDULE_PATH = "/content-schedule";
export const GAMES_PATH = "/games";
export const BRAND_TAB_PATH = "/brands/:id/:tabId";
export const BRAND_SUB_PAGE_PATH = "/brands/:id/:tabId/:tabDetailsId";
export const HELP_CENTER_PATH = "/help-center";
export const FAQ_GROUP_PATH = "/help-center/faqGroup";
export const FAQS_PATH = "/help-center/faqGroup/:id";
export const BULLETINS_PATH = "/help-center/bulletins";
export const TRANSLATIONS_PATH = "/translations";
export const TRANSLATIONS_STATIC_PATH = "/translations/static";
export const TRANSLATIONS_DYNAMIC_PATH = "/translations/dynamic";
export const ROLES_AND_PERMISSIONS = "/roles-permissions";
export const CUSTOMER_SERVICES_CENTRE = "/customer-services-centre";
export const USERS_PATH = "/telegram/users";
export const BROADCASTS_PATH = "/telegram/broadcasts";
export const MANAGE_ARTICLES_PATH = "/manage-articles/:brandId/:categoryId";
export const MANAGE_ARTICLES_GROUP_PATH =
  "/manage-articles/:brandId/:categoryId/:groupId";
export const MANAGE_ARTICLE_DETAILS_PATH =
  "/manage-articles/:brandId/:categoryId/:groupId/:id";
export const TELEGRAM_PATH = "/telegram";
